import createEnvironments from './endpoints';

export const environment = {
  ...createEnvironments('https://robuschi-ir-test.ir-digital.net', 'https://iotgatet01.seepex.com', 'https://monitoring.seepex.com'),

  accessRequest: {
    email: 'robuschi_websupport@irco.com',
    subject: 'Robuschi Selection Tool - Request access',
    toolUrl: 'https://robuschi-ir.ir-digital.net/',
  },

  production: false,
  envname: 'development',
};
